var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRemote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.238 4.938s-.2 1.467.067 2.4M21.671 7.138s-1.266.6-1.866 1.334M19.605 5.338s-1.1 1.167-1.267 2.1",
    stroke: "#0C0A0C",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.605 17.538h-1.4v-1.533c0-.167-.133-.3-.3-.3H17.07c-.166 0-.3.133-.3.3v1.533H14.806v-1.533c0-.167-.133-.3-.3-.3H12.67c-.166 0-.3.133-.3.3v1.533H9.405v-1.533c0-.167-.134-.3-.3-.3H7.27c-.166 0-.3.133-.3.3v1.533h-1.4c-.166 0-.3.134-.3.3v5.434h15.567v-5.434c0-.17 0-.3-.233-.3z",
    fill: "#fff",
    stroke: "#0C0A0C",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.372 17.7h10.2v-5.4c0-.166-.134-.3-.3-.3h-9.6c-.167 0-.3.134-.3.3v5.4z",
    fill: "#FF794F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.338 13.334h1.833c.167 0 .3-.134.3-.3v-2.567c0-.167-.133-.3-.3-.3h-1.833c-.167 0-.3.133-.3.3v2.567c.033.166.167.3.3.3zM16.738 13.334h1.833c.167 0 .3-.134.3-.3v-2.567c0-.167-.133-.3-.3-.3h-1.833c-.167 0-.3.133-.3.3v2.567c0 .166.133.3.3.3z",
    fill: "#FF794F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.872 21.671c2.233-.166 5.033-.266 7.466 0",
    stroke: "#0C0A0C",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.138 2.305c-.1-.134-.267-.134-.4-.034l-1.067.834-.933-1.167c-.1-.133-.267-.133-.4-.033l-1.4 1.1c-.133.1-.133.266-.033.4l.933 1.166-1.5 1.167-.933-1.167c-.1-.133-.267-.133-.4-.033l-1.4 1.1c-.1.1-.134.267-.034.4l.934 1.167-1.067.833c-.133.1-.133.267-.033.4l3.066 3.9c.1.133.267.133.4.033l7.3-5.8c.134-.1.134-.266.034-.4l-3.067-3.866z",
    fill: "#FF794F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.872 8.205a9.596 9.596 0 012.066 2.566M12.028 12.934a9.595 9.595 0 01.087 3.294",
    stroke: "#0C0A0C",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgRemote;